import React from 'react';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import { withNamespaces } from 'react-i18next';
import CommunityTopicsManager from 'apps/home/community/topics/appManager';

import Header from 'apps/components/header/header';
import { MainWrapper } from 'legacyComponents/styled/lib';
import { CardSection } from 'legacyComponents/layout/cardSection';
import { TopicCard } from 'legacyComponents/cards/types/topic';

import TagsList from './TagsList';

@withNamespaces()
@inject('routerStore')
@observer
export default class CommunityTopics extends React.Component {
  UNSAFE_componentWillMount() {
    this.appManager = new CommunityTopicsManager(null, this.props);
  }

  render() {
    const { t } = this.props;
    const connection = this.appManager.channelsConn;
    const topics = connection.arrayApp;
    return (
      <>
        <Header />
        <MainWrapper>
          <TagsList />
          <CardSection
            invisible={this.appManager.loading}
            title={t('All Topics')}
            subTitle=' '
            isOwnProfile={false}
            ownerName=''
            cardApp={topics}
            CardComponent={TopicCard}
            noDataCardType='topic'
            gridColumns={4}
            gridGap='default'
          />
        </MainWrapper>
      </>
    );
  }
}

CommunityTopics.propTypes = {
  t: PropTypes.func,
};
